var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ecommerce-app"}},[_c('ecommerce-header'),_c('main',{staticClass:"main-content"},[_c('Home')],1),_c('ecommerce-cart-sidebar'),_c('ecommerce-otp-modal'),_c('ecommerce-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }